import { render, staticRenderFns } from "./EinstellungenSubventionsbeitraege.vue?vue&type=template&id=27ecbfaa&"
import script from "./EinstellungenSubventionsbeitraege.vue?vue&type=script&lang=js&"
export * from "./EinstellungenSubventionsbeitraege.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports